<style lang="scss" type="text/scss" scoped>
  p{
    font-size: 20px;
    text-align: center;
    margin-top: 100px;
  }
</style>

<template>
  <div class="content">
    <el-main>
      <p>暂无权限，请联系管理员</p>
      <p><router-link to="/login"><el-button type="primary">返回登录页面</el-button></router-link></p>
    </el-main>

  </div>
</template>

<script>
    export default {
        name: '',
        data() {
            return {};
        },
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// src/page/NoJurisdiction.vue